import { WebResourceModalContent } from './WebResourceModalContent';
export default WebResourceModalContent;
